import { render } from "./EstablishTruths.vue?vue&type=template&id=3eb4e0c7&scoped=true"
import script from "./EstablishTruths.vue?vue&type=script&lang=js"
export * from "./EstablishTruths.vue?vue&type=script&lang=js"

import "./EstablishTruths.vue?vue&type=style&index=0&id=3eb4e0c7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shavin\\Documents\\apps\\10-candles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb4e0c7"]])

export default __exports__